import { MapCultureTo } from "../../../base-types";
import Guard from "../../../guard";
import { IOptionListValue } from "./option-list-value";

export default abstract class OptionListValueBase implements IOptionListValue {
    readonly identifier: string;

    readonly labels: MapCultureTo<string>;

    constructor(identifier: string, labels?: MapCultureTo<string>) {
        Guard.stringNotNullOrEmpty(identifier);
        this.identifier = identifier;
        this.labels = labels || {};
    }
}

export { OptionListValueBase };
